/****************************************************
 * Module Name:  potentialSell.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useMemo, useState } from "react";
import { DataGridPro, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Box, Button, IconButton, TextField, Tooltip, Typography, } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import Utility from "../../utility/utility";
import { useEffect } from "react";
import Constants from "../../utility/constants";
import renderCellExpand from "../common/dataGridCellExpand";
import EmployeeProxy from "../../utility/proxy/manager/employeeProxy";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CommonSnackbar from "../common/commonSnackBar";
import StoneProxy from "../../utility/proxy/manager/stoneProxy";
import LabProxy from "../../utility/proxy/manager/labProxy";
import LocationProxy from "../../utility/proxy/manager/locationProxy";
import CutProxy from "../../utility/proxy/manager/cutProxy";
import PolProxy from "../../utility/proxy/manager/polProxy";
import SymProxy from "../../utility/proxy/manager/symProxy";
import FloProxy from "../../utility/proxy/manager/floProxy";
import ClarityProxy from "../../utility/proxy/manager/clarityProxy";
import ColorProxy from "../../utility/proxy/manager/colorProxy";
import SizeProxy from "../../utility/proxy/manager/sizeProxy";
import ShapeProxy from "../../utility/proxy/manager/shapeProxy";
import FileCopyRoundedIcon from "@mui/icons-material/FileCopyRounded";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ClearIcon from '@mui/icons-material/Clear';
import SystemSalesModal from "./systemSalesModal";
import StoneTypeProxy from "../../utility/proxy/manager/stoneTypeProxy";
import PageTitle from "../common/pageTitle";

const PotentialSell = () => {
    const [listData, setListData] = useState([]);
    const [listLoader, setListLoader] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [snackBarTitle, setSnackBarTitle] = useState("");
    const [snackBarMessage, setSnackBarMessage] = useState("");
    const [snackBarVariant, setSnackBarVariant] = useState("");
    const [showSnackbar, setShowSnackbar] = useState(false);

    const [wolzaCriteria, setWolzaCriteria] = useState(Utility.getDefaultCriteriaToGenerateLink);

    const [labOptions, setLabOptions] = useState([]);
    const [locationOptions, setLocationOptions] = useState([]);
    const [cutOptions, setCutOptions] = useState([]);
    const [polOptions, setPolOptions] = useState([]);
    const [symOption, setSymOptions] = useState([]);
    const [floOption, setFloOptions] = useState([]);
    const [clarityOptions, setClarityOptions] = useState([]);
    const [colorOptions, setColorOptions] = useState([]);
    const [sizeOptions, setSizeOptions] = useState([]);
    const [shapeOptions, setShapeOptions] = useState([]);
    const [showInvoiceModal, setShowInvoiceModal] = useState(false);
    const [customerData, setCustomerData] = useState({
        customer: [],
        customerOptions: [],
    });
    const [filterValues, setFilterValues] = useState({});
    const [stoneTypeOptions, setStoneTypeOptions] = useState([]);
    const defaultStatus = [
        { value: "UNPAID", label: "UNPAID" },
        { value: "PAID", label: "PAID" }
    ];

    useEffect(() => {
        PageTitle("MASTER_POTENTIALSELL");
        LabProxy.GetAllLabMini((response) => {
            let lLabOption = [];
            response.map((data) => lLabOption.push({ value: data.name, label: data.name, selected: false }))
            setLabOptions(lLabOption);
        });

        LocationProxy.GetAllLocationDetailMini((response) => {
            let lLocationOption = [];
            response.map((data) => lLocationOption.push({ value: data.id, label: data.name, selected: false }));
            setLocationOptions(lLocationOption);
        });

        CutProxy.GetAllCutMini((response) => {
            let lCutOption = [];
            response.map((data) => lCutOption.push({ value: data.name, label: data.name, selected: false }));
            setCutOptions(lCutOption);
        });

        PolProxy.GetAllPolMini((response) => {
            let lPolOption = [];
            response.map((data) => lPolOption.push({ value: data.name, label: data.name, selected: false }));
            setPolOptions(lPolOption);
        });

        SymProxy.GetAllSymMini((response) => {
            let lSymOption = [];
            response.map((data) => lSymOption.push({ value: data.name, label: data.name, selected: false }));
            setSymOptions(lSymOption);
        });

        FloProxy.GetAllFloMini((response) => {
            let lFloOption = [];
            response.map((data) => lFloOption.push({ value: data.name, label: data.name, selected: false }));
            setFloOptions(lFloOption);
        });

        ClarityProxy.GetAllClarityMini((response) => {
            let lClarityOption = [];
            response.map((data) => lClarityOption.push({ value: data.name, label: data.name, selected: false }));
            setClarityOptions(lClarityOption);
        });

        ColorProxy.GetAllColorMini((response) => {
            let lColorOption = [];
            response.map((data) => lColorOption.push({ value: data.name, label: data.name, selected: false }));
            setColorOptions(lColorOption);
        });

        SizeProxy.GetAllSizeMini((response) => {
            let lWeightOption = [];
            response.map((iWeight) => lWeightOption.push({ value: iWeight.id, label: iWeight.name, selected: false }));
            setSizeOptions(lWeightOption);
        });

        ShapeProxy.GetAllShapeMini((response) => {
            let res = response.filter((iShape) => iShape.disabled === false);

            let lShapeOption = [];
            res.map((iShape) => lShapeOption.push({ value: iShape.id, label: iShape.name, selected: false, image: iShape.image }));

            setShapeOptions(lShapeOption);
        });
        StoneTypeProxy.GetAllStoneTypeByDisabled(false, response => {

            if (response) {
                let stoneTypeOption = [];
                response.map(stonetype => {
                    if (stonetype.name !== 'N')
                        stoneTypeOption.push({ value: stonetype.name, label: stonetype.fullname, selected: true })

                    return true;
                });
                setStoneTypeOptions(stoneTypeOption);
            }
        })
    }, []);

    useEffect(() => {
        let searchCriteria = wolzaCriteria;
        searchCriteria.labOption = labOptions;
        searchCriteria.locationOption = locationOptions;
        searchCriteria.cutOption = cutOptions;
        searchCriteria.polOption = polOptions;
        searchCriteria.symOption = symOption;
        searchCriteria.floOption = floOption;
        searchCriteria.shapeOption = shapeOptions;
        searchCriteria.colorOption = colorOptions;
        searchCriteria.clarityOption = clarityOptions;
        searchCriteria.weightOption = sizeOptions;
        searchCriteria.stonetypeOption = stoneTypeOptions;
        setWolzaCriteria(searchCriteria);
    }, [labOptions, locationOptions, cutOptions, polOptions, symOption, floOption, sizeOptions, shapeOptions, colorOptions, clarityOptions, stoneTypeOptions])

    // eslint-disable-next-line
    const [local_Permission, setLocal_Permission] = useState(
        Constants.USER_PERMISSION.filter(
            (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.MASTER_POTENTIALSELL
        )
    );

    const NATURAL = "N";

    const LAB_GROWN = "LG";

    const openLinkInNewTab = (link) => {
        window.open(link, '_blank', 'noopener,noreferrer');
    };

    const handleSearch = () => {

        let employeeid = local_Permission.length > 0 ? [-1] : [Constants.loggedInUser.id];

        let data = {
            from: (fromDate !== null && fromDate !== "") ?
                dayjs(fromDate).format('YYYY-MM-DD') + "T00:00:00.000Z" : null,
            to: (toDate !== null && toDate !== "") ?
                dayjs(toDate).format('YYYY-MM-DD') + "T23:59:59.999Z" : null,
            employeeids: employeeid,
        }

        setListLoader(true);
        EmployeeProxy.GetCustomerPotentialSellDetails(
            data,
            (responseData) => {
                if (responseData) {
                    const uniqueFilterValues = {
                        companyname: Utility.getDistinctOptions(responseData, "companyname"),
                        username: Utility.getDistinctOptions(responseData, "username"),
                        first_name: Utility.getDistinctOptions(responseData, "first_name"),
                        location: Utility.getDistinctOptions(responseData, "location"),
                        country: Utility.getDistinctOptions(responseData, "country"),
                        customercountry: Utility.getDistinctOptions(responseData, "customercountry"),
                        customerstate: Utility.getDistinctOptions(responseData, "customerstate"),
                        customercity: Utility.getDistinctOptions(responseData, "customercity"),
                    };

                    setFilterValues(uniqueFilterValues);
                    setListLoader(false);
                    let newListData = [];
                    responseData.forEach((res) => {
                        let listOp = {
                            ...res,
                            naturallink: "",
                            labgrownlink: "",
                        }
                        newListData.push(listOp);
                        return true;
                    })

                    setListData(newListData);
                } else {
                    setShowSnackbar(true)
                    setSnackBarMessage(Constants.APiFailErrorMessage)
                    setSnackBarVariant("error")
                    setSnackBarTitle("Failed")
                    setListLoader(false);
                }
            });
    };

    const generateLink = async (customerdata, stoneType) => {
        return new Promise((resolve, reject) => {
            let data = wolzaCriteria;
            data.selectedCustomer = {
                "label": customerdata.companyname,
                "value": customerdata.id,
            };

            data.stonetypeOption = stoneType === "N" ? [] : stoneTypeOptions;

            let reqData = {
                from: (fromDate !== null && fromDate !== "") ?
                    Utility.ConvertLocalTimeToUtc(fromDate).slice(0, 11) + "00:00:00.000Z" : null,
                to: (toDate !== null && toDate !== "") ?
                    Utility.ConvertLocalTimeToUtc(toDate).slice(0, 11) + "23:59:59.999Z" : null,

                createdby: Constants.loggedInUser.id,
                customerid: customerdata.id,
                consigneeid: -1,
                criteria: JSON.stringify(JSON.stringify(data)),
                stonetype: stoneType,
            }

            StoneProxy.GenerateCriteriaLinkForWolzaDataStoneIds(Constants.loggedInUser.id, reqData, (response) => {
                if (response) {
                    let link = `${window.location.origin}/app/operation/stock?id=${response.guid}`;
                    let newListData = [];
                    listData.forEach((res) => {
                        if (customerdata.id === res.id) {
                            let listOp;
                            if (stoneType === "N") {
                                listOp = {
                                    ...res,
                                    naturallink: link,
                                }
                            } else {
                                listOp = {
                                    ...res,
                                    labgrownlink: link,
                                }
                            }
                            newListData.push(listOp);
                        } else {
                            newListData.push(res);
                        }
                    });
                    setListData(newListData);
                    setShowSnackbar(true);
                    setSnackBarMessage("Link generated successfully");
                    setSnackBarVariant("success");
                    resolve(link);  // Resolve the Promise with the generated link
                } else {
                    setShowSnackbar(true);
                    setSnackBarMessage(Constants.APiFailErrorMessage);
                    setSnackBarVariant("error");
                    reject("Failed to generate link");  // Reject the Promise in case of failure
                }
            });
        });
    }

    const handleActualInvoiceDetail = (params) => {
        setShowInvoiceModal(true);
        let optionsArray = [];
        optionsArray.push({ value: "*", label: "-- ANY --" });
        optionsArray.push({ value: params.row.id, label: params.row.companyname })

        let customerData = {
            customerOptions: optionsArray,
            customer: [optionsArray[1]],
        }
        setCustomerData(customerData);
    }

    const columns = useMemo(() => [
        {
            field: "id",
            headerName: "USER ID",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            minWidth: 50,
        },
        {
            field: "companyname",
            headerName: "COMPANY NAME",
            headerAlign: "center",
            align: "center",
            minWidth: 150,
            flex: 1,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.companyname : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "username",
            headerName: "USER",
            headerAlign: "center",
            align: "center",
            minWidth: 130,
            flex: 1,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.username : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: "first_name",
            headerName: "NAME",
            headerAlign: "center",
            align: "center",
            minWidth: 130,
            flex: 1,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.first_name : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand,
        },
        {
            field: 'brokers',
            headerName: 'BROKERS',
            renderCell: (params) => {
                let brokerCompanyName = '';
                if (params.row.brokers !== null) {
                    params.row.brokers.forEach((iBroker) => {
                        brokerCompanyName += iBroker.companyname + ', ';
                    });
                }
                brokerCompanyName = brokerCompanyName.slice(0, -2);
                return brokerCompanyName;
            },
            valueGetter: (params) => {
                if (params.row.brokers !== null) {
                    return params.row.brokers.map((iBroker) => iBroker.companyname).join(', ');
                }
                return '';
            },
        },
        {
            field: "phoneno",
            headerAlign: "center",
            align: "center",
            headerName: "PHONE",
            width: 100,
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "location",
            headerAlign: "center",
            align: "center",
            headerName: "LOCATION",
            width: 100,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.location : [],
            filterOperators: Utility.combinedFilters(),
        },
        {
            field: "country",
            headerName: "LOCATION COUNTRY",
            headerAlign: "center",
            align: "center",
            minWidth: 60,
            flex: 1,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.country : [],
            filterOperators: Utility.combinedFilters(),
        },
        {
            field: "customercountry",
            headerName: "COUNTRY",
            headerAlign: "center",
            align: "center",
            minWidth: 60,
            flex: 1,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.customercountry : [],
            filterOperators: Utility.combinedFilters(),
        },
        {
            field: "customerstate",
            headerName: "STATE",
            headerAlign: "center",
            align: "center",
            minWidth: 60,
            flex: 1,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.customerstate : [],
            filterOperators: Utility.combinedFilters(),
        },
        {
            field: "customercity",
            headerName: "CITY",
            headerAlign: "center",
            align: "center",
            minWidth: 60,
            flex: 1,
            type: "singleSelect",
            valueOptions: filterValues ? filterValues.customercity : [],
            filterOperators: Utility.combinedFilters(),
        },
        {
            field: "actualsellstonecount",
            headerName: "N ACTUAL SELL COUNT",
            align: "center",
            headerAlign: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            Width: 70,
            cellClassName: 'greenCell',
            renderHeader: () => (
                <Tooltip title="Sell Count of Natural Stones from Our System" placement="bottom">
                    <span>N ACTUAL SELL COUNT</span>
                </Tooltip>
            ),
            renderCell: (params) => {
                const isClickable = params.value !== 0 && params.value !== null;

                return (
                    <Button
                        sx={{
                            textDecorationLine: isClickable ? "underline" : "none",
                            color: "black",
                            textTransform: "none",
                            cursor: isClickable ? "pointer" : "default",
                        }}
                        onClick={isClickable ? () => handleActualInvoiceDetail(params) : undefined}
                        disabled={!isClickable}
                    >
                        {isClickable ? params.value : ""}
                    </Button>
                );
            },
        },
        {
            field: "sumofactualsell",
            headerName: "N SUM OF ACTUAL SELL",
            headerAlign: "center",
            align: "center",
            width: 90,
            type: "number",
            renderHeader: () => (
                <Tooltip title="Total Sell Price of Natural Stones from Our System" placement="bottom">
                    <span>N SUM OF ACTUAL SELL</span>
                </Tooltip>
            ),
            cellClassName: 'greenCell',
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "stonecount",
            headerName: "N STONE COUNT",
            headerAlign: "center",
            align: "center",
            width: 110,
            type: "number",
            renderHeader: () => (
                <Tooltip title="Total Number of Available Natural Stones for Proposal to the Customer" placement="bottom">
                    <span>N STONE COUNT</span>
                </Tooltip>
            ),
            cellClassName: 'greenCell',
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "totalprice",
            headerName: "N TOTAL PRICE",
            headerAlign: "center",
            align: "center",
            width: 90,
            type: "number",
            renderHeader: () => (
                <Tooltip title="Total Price of Available Natural Stones for Customer Proposal" placement="bottom">
                    <span>N TOTAL PRICE</span>
                </Tooltip>
            ),
            cellClassName: 'greenCell',
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "link",
            headerName: "N LINK",
            headerAlign: "center",
            align: "center",
            export: false,
            width: 100,
            renderHeader: () => (
                <Tooltip title="Link for Available Natural Stones to Propose to the Customer" placement="bottom">
                    <span>N LINK</span>
                </Tooltip>
            ),
            cellClassName: 'greenCell',
            renderCell: (params) => {
                const rowData = params.row;
                const showLink = (rowData.stonecount && rowData.stonecount > 0);

                return (
                    <Box display="flex" justifyContent="center" alignItems="center">
                        {showLink && (
                            <>
                                <Tooltip title="Open Link">
                                    <IconButton
                                        onClick={async (event) => {

                                            try {
                                                const link = rowData.naturallink === "" ? await generateLink(rowData, NATURAL) : rowData.naturallink;
                                                openLinkInNewTab(link);
                                            } catch (error) {
                                                setShowSnackbar(true);
                                                setSnackBarMessage("Failed to generate link");
                                                setSnackBarVariant("error");
                                                setSnackBarTitle("Error");
                                            }

                                        }}
                                    >
                                        <OpenInNewIcon />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="Copy Link">
                                    <IconButton
                                        onClick={async (event) => {
                                            try {
                                                const link = rowData.naturallink === "" ? await generateLink(rowData, NATURAL) : rowData.naturallink;
                                                navigator.clipboard.writeText(link)
                                                    .then(() => {
                                                        setShowSnackbar(true);
                                                        setSnackBarMessage("Link Copied");
                                                        setSnackBarVariant("success");
                                                        setSnackBarTitle("Success");
                                                    })
                                                    .catch(err => {
                                                        console.error("Failed to copy link: ", err);
                                                    });
                                            } catch (error) {
                                                setShowSnackbar(true);
                                                setSnackBarMessage("Failed to copy link");
                                                setSnackBarVariant("error");
                                                setSnackBarTitle("Error");
                                            }
                                        }}
                                    >
                                        <FileCopyRoundedIcon />
                                    </IconButton>
                                </Tooltip>
                            </>
                        )}
                    </Box>
                );
            },
        },
        {
            field: "lg_actualsellstonecount",
            headerName: "LG ACTUAL SELL COUNT",
            align: "center",
            headerAlign: "center",
            minWidth: 70,
            type: "number",
            cellClassName: 'brownCell',
            valueFormatter: (params) => params.value,
            renderHeader: () => (
                <Tooltip title="Sell Count of Lab Grown Stones from Our System" placement="bottom">
                    <span>LG ACTUAL SELL COUNT</span>
                </Tooltip>
            ),
            flex: 1,
            renderCell: (params) => {
                const isClickable = params.value !== 0 && params.value !== null;

                return (
                    <Button
                        sx={{
                            textDecorationLine: "underline",
                            color: "black",
                            textTransform: "none",
                        }}
                        onClick={isClickable ? () => handleActualInvoiceDetail(params) : undefined}
                        disabled={!isClickable}
                    >
                        {isClickable ? params.value : ""}
                    </Button>)
            }
        },
        {
            field: "lg_sumofactualsell",
            headerName: "LG SUM OF ACTUAL SELL",
            headerAlign: "center",
            align: "center",
            minWidth: 90,
            flex: 1,
            type: "number",
            cellClassName: 'brownCell',
            renderHeader: () => (
                <Tooltip title="Total Sell Price of Lab Grown Stones from Our System" placement="bottom">
                    <span>LG SUM OF ACTUAL SELL</span>
                </Tooltip>
            ),
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "lg_stonecount",
            headerName: "LG STONE COUNT",
            headerAlign: "center",
            align: "center",
            minWidth: 120,
            flex: 1,
            type: "number",
            cellClassName: 'brownCell',
            renderHeader: () => (
                <Tooltip title="Total Number of Available Lab Grown Stones for Proposal to the Customer" placement="bottom">
                    <span>LG STONE COUNT</span>
                </Tooltip>
            ),
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "lg_totalprice",
            headerName: "LG TOTAL PRICE",
            headerAlign: "center",
            align: "center",
            minWidth: 90,
            flex: 1,
            type: "number",
            cellClassName: 'brownCell',
            renderHeader: () => (
                <Tooltip title="Total Price of Available Lab Grown Stones for Customer Proposal" placement="bottom">
                    <span>LG TOTAL PRICE</span>
                </Tooltip>
            ),
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand,
        },
        {
            field: "lg_link",
            headerName: "LG LINK",
            headerAlign: "center",
            align: "center",
            export: false,
            Width: 90,
            cellClassName: 'brownCell',
            renderHeader: () => (
                <Tooltip title="Link for Available Lab Grown Stones to Propose to the Customer" placement="bottom">
                    <span>LG LINK</span>
                </Tooltip>
            ),
            renderCell: (params) => {
                const rowData = params.row;
                const showLink = (rowData.lg_stonecount && rowData.lg_stonecount > 0);

                return (
                    <Box display="flex" justifyContent="center" alignItems="center">
                        {showLink && (
                            <>
                                <Tooltip title="Open Link">
                                    <IconButton
                                        onClick={async (event) => {

                                            try {
                                                const link = rowData.labgrownlink === "" ? await generateLink(rowData, LAB_GROWN) : rowData.labgrownlink;
                                                openLinkInNewTab(link);
                                            } catch (error) {
                                                setShowSnackbar(true);
                                                setSnackBarMessage("Failed to generate link");
                                                setSnackBarVariant("error");
                                                setSnackBarTitle("Error");
                                            }

                                        }}
                                    >
                                        <OpenInNewIcon />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="Copy Link">
                                    <IconButton
                                        onClick={async (event) => {
                                            try {
                                                const link = rowData.labgrownlink === "" ? await generateLink(rowData, LAB_GROWN) : rowData.labgrownlink;
                                                navigator.clipboard.writeText(link)
                                                    .then(() => {
                                                        setShowSnackbar(true);
                                                        setSnackBarMessage("Link Copied");
                                                        setSnackBarVariant("success");
                                                        setSnackBarTitle("Success");
                                                    })
                                                    .catch(err => {
                                                        console.error("Failed to copy link: ", err);
                                                    });
                                            } catch (error) {
                                                setShowSnackbar(true);
                                                setSnackBarMessage("Failed to copy link");
                                                setSnackBarVariant("error");
                                                setSnackBarTitle("Error");
                                            }
                                        }}
                                    >
                                        <FileCopyRoundedIcon />
                                    </IconButton>
                                </Tooltip>
                            </>
                        )}</Box>
                );
            },
        },
    ], [filterValues]);

    const rows = listData;

    const CustomToolbar = () => {
        return (
            <GridToolbarContainer
                sx={{
                    display: "flex",
                    alignItems: "center",
                    marginHorizontal: "5px",
                    "&.MuiDataGrid-toolbarContainer": {
                        padding: "0px 4px !important",
                    },
                }}
            >
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarExport />
                <Box sx={{ flexGrow: 1, display: { sm: "none", md: "block" } }} />
                {listLoader ? (
                    <CircularProgress size="1rem" />
                ) : (
                    <Tooltip title="Reload List">
                        <RefreshOutlinedIcon
                            onClick={() => handleSearch()}
                            color="primary"
                            fontSize="medium"
                            sx={{ cursor: "pointer", mr: 1 }}
                        />
                    </Tooltip>
                )}

                <GridToolbarQuickFilter debounceMs={500} />
            </GridToolbarContainer>
        );
    }

    return (

        <div>
            {showInvoiceModal ? (
                <SystemSalesModal
                    show={showInvoiceModal}
                    handleClose={() => setShowInvoiceModal(false)}
                    loadedCustomers={customerData}
                    defaultfromdate={fromDate}
                    defaulttodate={toDate}
                    defaultStatus={defaultStatus}
                    onHide={() => setShowInvoiceModal(false)}
                />
            ) : null}
            {showSnackbar ? (
                <CommonSnackbar
                    show={showSnackbar}
                    message={snackBarMessage}
                    variant={snackBarVariant}
                    autoHide={false}
                    title={snackBarTitle}
                    handleClose={() => { setShowSnackbar(false); }}
                />)
                : null}

            <div>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        gap: 2,
                        my: 2,
                        ml: { xs: 0, sm: 2 },
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "15px",
                            width: "100%",
                            alignItems: "center",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" },
                                alignItems: { xs: "flex-start", sm: "center" },
                                gap: "10px",
                                width: { xs: "100%", sm: "auto" },
                                "& .MuiOutlinedInput-root": {
                                    height: "2.45rem",
                                },
                            }}
                        >
                            <Typography mt={{ xs: 0, sm: 1 }}>From</Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    className="picker"
                                    renderInput={(props) => (
                                        <TextField
                                            fullWidth
                                            {...props}
                                            inputProps={{ ...props.inputProps, readOnly: true }}
                                        />
                                    )}
                                    value={fromDate}
                                    inputFormat="DD/MM/YYYY"
                                    onChange={(newValue) => {
                                        const now = dayjs();
                                        const fromDate = dayjs(newValue)
                                            .hour(now.hour())
                                            .minute(now.minute())
                                            .second(now.second())
                                            .millisecond(now.millisecond())
                                            .toDate();
                                        setFromDate(fromDate);
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>

                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" },
                                alignItems: { xs: "flex-start", sm: "center" },
                                gap: "10px",
                                width: { xs: "100%", sm: "auto" },
                                "& .MuiOutlinedInput-root": {
                                    height: "2.45rem",
                                },
                            }}
                        >
                            <Typography mt={{ xs: 0, sm: 1 }}>To</Typography>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    className="picker"
                                    renderInput={(props) => (
                                        <TextField
                                            fullWidth
                                            {...props}
                                            inputProps={{ ...props.inputProps, readOnly: true }}
                                        />
                                    )}
                                    value={toDate}
                                    inputFormat="DD/MM/YYYY"
                                    onChange={(newValue) => {
                                        const now = dayjs();
                                        const toDate = dayjs(newValue)
                                            .hour(now.hour())
                                            .minute(now.minute())
                                            .second(now.second())
                                            .millisecond(now.millisecond())
                                            .toDate();
                                        setToDate(toDate);
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>

                        <Box mt={{ xs: 0, sm: "0.4rem" }}>
                            <Tooltip title="Clear Dates">
                                <ClearIcon
                                    onClick={() => {
                                        setFromDate(null);
                                        setToDate(null);
                                    }}
                                    color="primary"
                                    fontSize="medium"
                                    sx={{ cursor: "pointer", mr: 1 }}
                                />
                            </Tooltip>
                        </Box>
                        <Box
                            sx={{
                                "& .Mui-disabled": {
                                    backgroundColor: "rgba(0, 0, 0, 0.12) !important",
                                    color: "rgba(0, 0, 0, 0.26) !important",
                                },
                                width: { xs: "100%", sm: "auto" },
                                alignSelf: { xs: "stretch", sm: "center" },
                            }}
                        >
                            <Button
                                variant="contained"
                                size="medium"
                                onClick={() => handleSearch()}
                                startIcon={<SearchOutlinedIcon size="large" />}
                                sx={{ alignSelf: "center", ml: 2 }}
                                disabled={listLoader}
                            >
                                Search
                            </Button>
                        </Box>
                    </Box>
                </Box>
                <Box
                    sx={{
                        px: 1,
                        width: "100%",
                        position: "relative",
                        backgroundColor: '#fff',
                        color: '#000',
                        "& .MuiTablePagination-selectLabel": {
                            marginTop: "15px",
                        },
                        "& .MuiTablePagination-displayedRows": {
                            marginTop: "15px",
                        },
                        "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                            fontWeight: Constants.defaultFontWeight,
                        },
                        "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                            color: "#1976d2",
                            padding: "4px 5px",
                            borderRadius: "4px",
                        },
                        "& .css-znmrd6-MuiButtonBase-root-MuiButton-root": {
                            color: "#1976d2",
                            padding: "5px 5px",
                            borderRadius: "4px",
                        },
                        "& .css-cc8tf1": {
                            fontWeight: Constants.defaultFontWeight,
                        },
                        "& .greenCell": {
                            color: "#080808",
                            backgroundColor: "#C6DCBA",
                        },
                        "& .brownCell": {
                            color: "#080808",
                            backgroundColor: "#ebbdaa",
                        },
                        height: "75vh",
                    }}
                >
                    <DataGridPro
                        sx={{
                            '& .MuiDataGrid-columnHeader': {
                                color: '#fff',
                                backgroundColor: 'grey',
                            },
                            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                py: "6px",
                            },
                            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                py: "12px",
                            },
                            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                py: "18px",
                            },

                            fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                        }}
                        density="compact"
                        disableRowSelectionOnClick={true}
                        slots={{ toolbar: CustomToolbar }}
                        rows={rows}
                        columns={columns}
                        getRowId={(row) => row.id}
                        loading={listLoader}
                        initialState={{
                            columns: {
                                columnVisibilityModel: {
                                    // Hide columns id, the other columns will remain visible
                                    locationid: false,
                                },
                            },
                            pagination: {
                                paginationModel: Constants.pageSize,
                            },
                        }}
                        pageSizeOptions={Constants.pageSizeOptions}
                        pagination
                        slotProps={{
                            toolbar: {
                                showQuickFilter: true,
                                quickFilterProps: {
                                    debounceMs: 500,
                                },
                            },
                        }}
                    />
                </Box>
            </div>
        </div>
    );
};
export default PotentialSell;
